import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
// import Login from "./component/Login";
import Header from "./component/Header";
import Home from "./component/Home";
import AddQus from "./component/AddQus";
import { useContext } from "react";
import LoginContext from "./component/LoginContext";
import LoadingSpinner from "./component/dialog/LoadingSpinner";
import DialogModel from "./component/dialog/DialogModel";
import ListQus from "./component/ListQus";
import GenQus from "./component/GenQus";
import LoginPage from "./component/LoginPage";
import AllQuestionVisuals from "./component/AllQuestionVisuals";
import Dashboard from "./component/userDashboard/Dashboard";

function App() {
  const { isLoading, modelData, setModelData }: any =
    useContext(LoginContext);
  return (
    <div className="App">
      {isLoading && <LoadingSpinner />}
      {modelData.isOpen && (
        <DialogModel
          title={"Save Question"}
          message={modelData.message}
          setModelData={setModelData}
        />
      )}

      <Header />
      <Routes>
        <Route path="/addqus" element={<AddQus />} />
        <Route path="/editqus/:qusId" element={<AddQus />} />
        <Route path="/allqusstats" element={<AllQuestionVisuals />} />
        <Route path="/listqus" element={<ListQus />} />
        <Route path="/genQus" element={<GenQus />} />
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </div>
  );
}

export default App;
